<template>

    <Loader v-if="!loaded" />
	<div v-else class="inner screening-upload-container">
        <div v-if="!allowed">
            Cannot show screening at this time
        </div>
        <div v-else>
            <div class="overview-nav" :class="openOverviewNav ? 'closed': 'open'">

                <div class="toggle-bar" @click="toggleOverviewNav">
                    <div class="icon">
                        <SvgIcon icon="toggle" />
                    </div>
                </div>

                <div class="headline">
                    <h1>{{$t('screening-upload.headline')}}</h1>
                </div>

            </div>

    		<div class="screening-upload" :class="openOverviewNav ? 'closed': 'open'">

    			<div class="completion">
    				<p>{{getScreeningStatus}}% {{$t('screening-upload.complete')}}</p>
    				<div class="bar">
    					<div class="result" :style="'width:' +getScreeningStatus +'%'"></div>
    				</div>
    			</div>
    			<div class="progress-bar">
    				<div class="result" :style="'height: calc(' +getScreeningStatus +'% + 5%);'"></div>
    			</div>

    			<tabs ref="tabList" class="upload-tabs">

    				<tab id="profile-picture" :name="$t('tabname.profile-picture')">
    					<image-upload ref="profilePictureUpload"></image-upload>
                        <div class="input-container">
                            <p class="subject">{{ $t('label.contact-info.subject') }}</p>
                            <div>
                                <form><input type="text" :placeholder="$t('input.phoneno.placeholder')" v-model="phone" v-on:change="savePhone" autofill="off" autocomplete="false" /></form>
                            </div>
                        </div>
                        <div class="seperator"></div>
                        <a href="#verification" v-if="phone" class="purple button">
                            <span>{{$t('button.continue')}}</span>
                        </a>
                        <button disabled v-else class="purple button">
                            <span>{{$t('button.continue')}}</span>
                        </button>
    				</tab>

    				<tab id="verification" :name="$t('tabname.verification')">
        				<verification v-if="!isVerified && loaded && openNemId" :expat="without_nemid"></verification>
                        <verification v-if="loaded && isVerified" done="1"></verification>
    				</tab>

                    <tab id="occupation" :name="$t('tabname.occupation')">
                        <h2>{{$t('screening-upload.occupation.headline')}}</h2>
                        <p class="text">{{$t('screening-upload.occupation.description')}}</p>
                        <div class="seperator"></div>
                        <input type="hidden" v-model="linkedInProfileUrl" placeholder="LinkedIn URL" readonly="true" />
                        <!-- LinkedIn Authentication and selection interface -->
                        <div class="connect" v-show="true">
                            <button v-if="!linkedInSuccessful" :disabled="linkedInInProgress" v-on:click="linkedInAuth" class="linkedin purple">
                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                     width="20px" height="20px" viewBox="0 0 32 32" enable-background="new 0 0 32 32" xml:space="preserve">
                                <path fill="#ffffff" d="M30.7,0H1.3C0.6,0,0,0.6,0,1.3v29.3C0,31.4,0.6,32,1.3,32h29.3c0.7,0,1.3-0.6,1.3-1.3V1.3
                                    C32,0.6,31.4,0,30.7,0z M9.5,27.3H4.7V12h4.8V27.3z M7.1,9.9c-1.5,0-2.8-1.2-2.8-2.8c0-1.5,1.2-2.8,2.8-2.8c1.5,0,2.8,1.2,2.8,2.8
                                    C9.9,8.7,8.6,9.9,7.1,9.9z M27.3,27.3h-4.7v-7.4c0-1.8,0-4-2.5-4c-2.5,0-2.8,1.9-2.8,3.9v7.6h-4.7V12H17v2.1h0.1
                                    c0.6-1.2,2.2-2.5,4.5-2.5c4.8,0,5.7,3.2,5.7,7.3V27.3z"/>
                                </svg>

                                <span v-if="!linkedInInProgress">{{ $t('screening-upload.linkedin.use.button') }}</span>
                                <span v-if="linkedInInProgress">{{ $t('please-wait') }}</span>
                            </button>

                            <div class="select-list" v-if="linkedInJobList.length > 1">
                                <div class="top">
                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                     width="20px" height="20px" viewBox="0 0 32 32" enable-background="new 0 0 32 32" xml:space="preserve">
                                    <path fill="#ffffff" d="M30.7,0H1.3C0.6,0,0,0.6,0,1.3v29.3C0,31.4,0.6,32,1.3,32h29.3c0.7,0,1.3-0.6,1.3-1.3V1.3
                                        C32,0.6,31.4,0,30.7,0z M9.5,27.3H4.7V12h4.8V27.3z M7.1,9.9c-1.5,0-2.8-1.2-2.8-2.8c0-1.5,1.2-2.8,2.8-2.8c1.5,0,2.8,1.2,2.8,2.8
                                        C9.9,8.7,8.6,9.9,7.1,9.9z M27.3,27.3h-4.7v-7.4c0-1.8,0-4-2.5-4c-2.5,0-2.8,1.9-2.8,3.9v7.6h-4.7V12H17v2.1h0.1
                                        c0.6-1.2,2.2-2.5,4.5-2.5c4.8,0,5.7,3.2,5.7,7.3V27.3z"/>
                                    </svg>
                                    <p>{{$t('screening-upload.linkedin.choose-title')}}</p>
                                </div>
                                <div class="list">
                                    <div class="item" v-on:click="selectLinkedInJob(i)" v-for="(job, i) in linkedInJobList">
                                        {{ job.title }}, {{ job.company.name }}
                                    </div>
                                </div>
                            </div>

                        </div>
                        <!-- LinkedIn -->
                        <occupation :linkedinjob="jobFromLinkedIn" ref="occupation"></occupation>
                    </tab>

    				<!-- <tab id="rki-status" :name="$t('tabname.rki-status')">
    					<rki-status></rki-status>
    					<a class="purple button" href="#income">{{$t('button.continue')}}</a>
    				</tab> -->

                    <tab id="income" :name="$t('tabname.income')">
                        <income ref="income" v-on:complete="incomeCompleted" v-model="incomeAmount"></income>
                    </tab>

                    <tab id="review" :name="$t('tabname.review')">
                        <h2>{{$t('screening-upload.review.headline')}}</h2>
                        <p class="text">{{$t('screening-upload.review.description')}}</p>
                        <div class="seperator"></div>
                        <button :disabled="completing" v-on:click="completeScreening" class="purple">
                            <template v-if="!completing">{{$t('button.complete-screening')}}</template>
                            <template v-if="completing">{{$t('loading')}}</template>
                        </button>
                    </tab>
    			</tabs>
    		</div>
        </div>
	</div>

</template>

<script>
    import Vue from 'vue';

    import ImageUpload from '../screenings/parts/ImageUpload'
    import Verification from '../screenings/parts/Verification'
    import Income from '../screenings/parts/Income'
    import RkiStatus from '../screenings/parts/RkiStatus'
	import Occupation from '../screenings/parts/Occupation'
    import Loader from '../../components/Loader.vue';
    import {mapGetters} from 'vuex';
    import DateTimeInput from '../../components/DateTimeInput.vue';
    import SvgIcon from '../../components/Svg.vue';

    export default {
    	components: {
            ImageUpload,
            Verification,
            Income,
            RkiStatus,
            Occupation,
            DateTimeInput,
            Loader,
            SvgIcon
    	},
    	data: () => ({
            without_nemid: false,
            openOverviewNav: false,
            incomeAmount: 0,
            readOnlyFields: false,
            completing: false,
            occupation: Occupation,
            linkedInInProgress: false,
            linkedInSuccessful: false,
            linkedInProfileUrl: '',
            jobFromLinkedIn: false,
            loaded: false,
            allowed: false,
    		phone: '',
    		showThis: false,
            linkedInJobList: [],
            rkiDefined: false,
			disabledTabs: {
                profilePicture: false,
                verifyIdentity: true,
                income: false,
                rkiStatus: false,
                occupation: false,
			},
            cachedLinkedInResponse: false
    	}),
    	methods: {
            toggleOverviewNav: function() {
                this.openOverviewNav = !this.openOverviewNav
            },
            incomeCompleted() {

            },
            testNordicApiCode() {
                return;

                if (!this.isNordicApiRequest()) {
                    return;
                }
                var code = this.$route.query.code;
                if (code && !this.getNordicApiToken) {
                    axios({
                        method: 'POST',
                        url: window.config.apiUrl + 'api/nordicapi/token',
                        cancelToken: window.AuthorizationCancelSource.token,
                        data: {
                            code: code
                        }
                    }).then(response => {
                        this.$store.commit('setNordicApiToken', response.data.token);
                    }).finally(e => {
                        this.openingBankScreen = false;
                    });
                }
            },
            markBulletsAsCompleted() {
                var self = this;
                if (!this.$refs.tabList) {
                    return;
                }
                let someCollection = document.querySelectorAll('.tabs-component-tabs li')
                Array.from(someCollection).forEach(function(item) {
                    var useFill = self.tabIsCompleted(item.firstChild.href.replace(/^.*?#([a-z\-\_0-9]+)$/, '$1'));
                    if (useFill) {
                        if (item.className.indexOf('is-filled') == -1) {
                            item.className = item.className + ' is-filled';
                        }
                    } else {
                        item.className = item.className.replace('is-filled', '').replace('  ', ' ');
                    }
                })
            },
            tabIsCompleted(tab) {
                switch (tab) {
                    case 'profile-picture':
                        return this.phone && this.$refs.profilePictureUpload.hasUploadedPicture;
                    case 'verification':
                        return this.isVerified;
                    case 'rki-status':
                        return this.rkiDefined;
                    case 'income':
                        return this.$refs.income.isFilled();
                    case 'occupation':
                        return this.$refs.occupation.isFilled();
                    case 'review':
                        return
                            (
                                this.phone
                                &&
                                this.$refs.profilePictureUpload.hasUploadedPicture()
                                &&
                                this.isVerified
                                &&
                                this.$refs.income.isFilled()
                                &&
                                this.$refs.occupation.isFilled()
                            );
                }
            },
            completeScreening() {
                this.completing = true;
                axios({
                    method: 'POST',
                    url: window.config.apiUrl + 'api/complete-screening',
                    cancelToken: window.AuthorizationCancelSource.token,
                }).then(response => {
                    this.$router.go(0);
                }).finally(e => {
                    this.completing = false;
                });
            },
            handleLinkedInResponse(response) {
                this.linkedInInProgress = false;
                if (response._total > 0) {
                    var person = response.values[0];
                    var picture = person.pictureUrl;
                    var positions = person.positions.values;
                    this.linkedInProfileUrl = person.publicProfileUrl;
                    this.linkedInJobList = positions;
                    this.linkedInSuccessful = true;
                    if (typeof positions != 'array') {
                        this.$swal(this.$t('screening-upload.linkedin.no-positions.error'), [], 'error');
                    } else if (positions.length == 1) {
                        this.selectLinkedInJob(0);
                    }
                    this.handleLinkedInProfilePicture(person);
                }
            },
            handleLinkedInProfilePicture(person) {
                if (!this.getPictureUrl) {
                    console.info('Profile photo replaced by LinkedIn');
                    axios({
                        url: window.config.apiUrl + 'api/user/image',
                        method: 'POST',
                        cancelToken: window.AuthorizationCancelSource.token,
                        data: {
                            importUrl: person.pictureUrl
                        },

                    }).then(response => {
                        this.markBulletsAsCompleted();
                    });
                }
            },
            selectLinkedInJob(i) {
                let job = this.linkedInJobList[i];
                let month = (job.startDate.month < 10 ? '0' + job.startDate.month : job.startDate.month);
                let startDate = job.startDate.year + '-' + month + '-01';
                this.$refs.occupation.setEmployment(job.title, job.company.name, startDate, this.linkedInProfileUrl);
                this.jobFromLinkedIn = true;
                this.linkedInJobList = [];
            },
            linkedInHandle(code) {
                if (code && this.isLinkedInApiRequest()) {
                    axios({
                        method: 'POST',
                        url: window.config.apiUrl + 'api/user/linkedin-jobs',
                        cancelToken: window.AuthorizationCancelSource.token,
                        data: {
                            code: code
                        }
                    });
                }
            },
            linkedInAuth() {
                if (this.cachedLinkedInResponse) {
                    this.handleLinkedInResponse(this.cachedLinkedInResponse);
                } else {
                    location.href = 'https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=811kbyrxt8xno5&redirect_uri='
                        + encodeURI(location.href) + '&scope=r_liteprofile';
                }
            },
            refreshProgress() {
                axios({
                    method: 'POST',
                    url: window.config.apiUrl + 'api/screening/refresh-progress',
                    cancelToken: window.AuthorizationCancelSource.token,
                }).then(response => {

                });
            },
    		savePhone() {
    			var self = this;
    			axios({
    				method: 'PATCH',
    				url: window.config.apiUrl + 'api/contact',
                    cancelToken: window.AuthorizationCancelSource.token,
    				data: {
    					phone: this.phone
    				}
    			}).then(response => {
                    this.refreshScreeningStatus();
                    this.$store.commit('setSuccessBarMessage', this.$t('screening-upload.phone-saved.label'));
                    this.markBulletsAsCompleted();
    			});
    		},
            refreshScreeningStatus() {
                this.$store.dispatch('fetchScreeningStatus', this.fetchScreeningStatusCallback);
            },
            fetchScreeningStatusCallback(response) {
                if (response.progress == 100) {
                    this.$router.push('/my-profile');
                }

                this.loaded = true;
                this.disabledTabs['income'] = false;
                this.markBulletsAsCompleted();
            },
            verificationCompleted() {
                this.$store.dispatch('fetchUserData', {
                    callback: () => {
                        this.$refs.tabList.selectTab(this.$refs.tabList.getTabHash(2));
                    }
                });
            },
            saveIncome() {
                axios({
                    method: 'PATCH',
                    url: window.config.apiUrl + 'api/income',
                    cancelToken: window.AuthorizationCancelSource.token,
                    data: {
                        income: this.incomeAmount
                    }
                }).then(response => {
                    this.refreshScreeningStatus();
                    this.$store.commit('setSuccessBarMessage', this.$t('screening-upload.income-saved.label'));
                });
            },
            isLinkedInApiRequest() {
                return true;
            },
    	},
		computed:{
			...mapGetters([
                'isVerified',
			    'getToken',
				'getScreeningStatus',
                'getPictureUrl',
                'getNordicApiToken'
			]),
            openNemId() {
                return !this.isVerified;
            }
		},
		mounted(){
            this.linkedInHandle(this.$route.query.code);

            this.$root.$on('statement-changed', (data) => {
                this.incomeAmount = data;
            });
            this.testNordicApiCode();

            var self = this;
            this.markBulletsAsCompleted();

            let linkedInScript = document.createElement('script')
            linkedInScript.setAttribute('src', '//platform.linkedin.com/in.js')
            linkedInScript.innerText = 'api_key: 811kbyrxt8xno5';
            // linkedInScript.innerText = 'api_key: oSbDioGDuaiBoGrc';
            document.getElementsByTagName('head')[0].appendChild(linkedInScript);

    	    this.$store.dispatch('fetchScreeningStatus', this.fetchScreeningStatusCallback);
            this.$root.$on('tab', (text, value) => {
                this.disabledTabs[text] = false;
            });
            this.$root.$on('verificationCompleted', () => {
                this.verificationCompleted();
            });
            this.$root.$on('refreshScreeningStatus', () => {
                this.refreshScreeningStatus();
            });

            this.$root.$on('killLinkedInJob', () => {
                this.linkedInJobList = [];
                this.linkedInSuccessful = false;
            });

            this.$root.$on('setTenantScreeningTab', (id) => {
                this.$refs.tabList.selectTab(this.$refs.tabList.getTabHash(id - 1));
            });

            axios({
                method: 'POST',
                url: window.config.apiUrl + 'api/user/info',

            }).then(response => {
                this.loaded = true;

                if (!response.data.invite) {
                    this.kill();
                    return;
                }

                if (!response.data.invite.sent_at) {
                    this.kill();
                    return;
                }

                this.allowed = true;

                if (response.data.screeningCompleted) {
                    this.$router.push('/my-profile');
                }

                this.without_nemid = !! response.data.verificationFile;
            	this.phone = response.data.phone;
                this.rkiDefined = response.data.rkiDefined;
                this.incomeAmount = response.data.income;
                this.markBulletsAsCompleted();
            });

            this.$store.dispatch('fetchUserData');

            window.addEventListener('hashchange', () => this.refreshScreeningStatus());
		}
    }

</script>
<style>

</style>
